// extracted by mini-css-extract-plugin
export default {"container":"ProtectedPage_container__Nwvpx","error":"ProtectedPage_error__9I0VW"};